export default __webpack_public_path__ + "static/media/product2.491d8683.png";